module.exports = __webpack_public_path__ + "static/barber-logo-white-01abd370eecd8f47114e744fe0623896.png";